module.exports = __webpack_public_path__ + "static/img/loginBg.12b8d1cd.png";